/**
 * @generated SignedSource<<65cbeaffaf0a9523c3b3eccb4150e639>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resellerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vendorId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "resellerid",
        "variableName": "resellerId"
      },
      {
        "kind": "Variable",
        "name": "vendorid",
        "variableName": "vendorId"
      }
    ],
    "concreteType": "ResellerAppsOemToVendorsConnection",
    "kind": "LinkedField",
    "name": "getresellerappsoemtovendor",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ResellerAppsOemToVendor",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appSku",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appLogo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oemAppId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oemAppName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oemAppSku",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ResellerPlanDescription",
            "kind": "LinkedField",
            "name": "plans",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "resellerPId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "programName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numSubs",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorPartnerProgramBlockAppsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VendorPartnerProgramBlockAppsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8e0aec68be07de33a3ad5a5495768602",
    "id": null,
    "metadata": {},
    "name": "VendorPartnerProgramBlockAppsQuery",
    "operationKind": "query",
    "text": "query VendorPartnerProgramBlockAppsQuery(\n  $resellerId: UUID!\n  $vendorId: UUID!\n) {\n  getresellerappsoemtovendor(resellerid: $resellerId, vendorid: $vendorId) {\n    totalCount\n    nodes {\n      appId\n      appName\n      appSku\n      appLogo\n      oemAppId\n      oemAppName\n      oemAppSku\n      plans {\n        resellerPId\n        programName\n        description\n      }\n      numSubs\n    }\n  }\n}\n"
  }
};
})();

node.hash = "8c2cdab5227e53cb8f64db6387e0b7d3";

module.exports = node;
